import { render, staticRenderFns } from "./UserSettings.handler.vue?vue&type=template&id=35e1537a&"
import script from "./UserSettings.handler.vue?vue&type=script&lang=ts&"
export * from "./UserSettings.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports